import {
    createReducer,
    createActionResources
  } from "redux-waiters";
  import { RESET_REDUCER } from "../constants";
  
  export const searchUserReportsAction = createActionResources("userReports/search");

  export const getUserReportDetailsAction = createActionResources("userReports/getDetails");

  const initialState = {
    fetching: false,
    userReports: [],
    total: 0,
    totalPages: 0,
    pageNumber: 1,
    error: {},
  };
  
  export default createReducer(
    {
      [searchUserReportsAction.start]: state => {
        return { ...state, fetching: true };
      },
      [searchUserReportsAction.success]: (state, action) => {
        return {
          ...state,
          userReports: action.data?.content,
          pageNumber: action.data?.pageNumber + 1,
          total: action.data?.total,
          totalPages: Math.ceil(action.data?.total / action.data?.pageSize),
          fetching: false,
        };
      },
      [searchUserReportsAction.error]: state => {
        return { ...state, fetching: false };
      },
  
      [RESET_REDUCER]: () => initialState,
    },
    initialState
  );